import React from 'react';

import { Typography } from '@mui/material';

import { IJiraStatus } from '~/domain/IJiraStatus';

interface IDisplayJiraStatus {
  status: IJiraStatus;
  disabled?: boolean;
  format?: (status: IJiraStatus) => React.ReactNode;
}

const getColor = (status: IJiraStatus) => {
  if (status.statusCategory.key === 'new') {
    return { background: '#F1F6FF', border: '#CEDAF1' };
  }
  else if (status.statusCategory.key === 'indeterminate') {
    return { background: '#FFF7EC', border: '#F1E0CE' };
  }
  else { // status.statusCategory.key === 'done'
    return { background: '#F3FAF5', border: '#B0D2C1' };
  }
}

export const DisplayJiraStatus: React.FC<IDisplayJiraStatus> = (props) => {
  const { status, disabled, format } = props;
  const color = getColor(status);

  return (
    <Typography
      sx={({ palette: { text } }) => ({
        fontSize: '14px',
        lineHeight: '18px',
        fontWeight: '500',
        width: 'fit-content',
        border: '1px solid',
        borderRadius: '4px',
        padding: '5px 16px',
        bgcolor: color.background,
        color: disabled ? text.secondary : text.primary,
        borderColor: color.border,
      })}
    >
      {format ? format(status) : status.name}
    </Typography>
  );
}
